module.exports = __webpack_public_path__ + "static/img/mode-group_disabled@2x.25b9d865.png";